/*eslint-disable */
import AreaChart from "../chart-data/AreaChart.vue";
const $ = window.jQuery = require('jquery'); 
export default {
  name: 'covid-19-popup',
  components: {
    AreaChart
  },
  props: [],
  data () {
    return {
      chartDraw:false,
      graphSHow:false,
      effective_contact_rate:'',
      recover_inday:'',
      recovered:'',
      contact_rate:'',
      submitted:false,
      chartGraphLoading:true,
      graphSHowLabel:false,
      python:`
      import numpy as np
      import matplotlib.pyplot as plt
      import random
      plt.style.use('ggplot')
      
      
      
      def probablities(state, parameter):
          prob = [parameter[0]*state[0]*state[1], parameter[1]*state[1]]
          return prob
      
      def gillespie(population=1000,  transmission_rate = 0.1,  R_0 = 2, max_time = 100):
          state = [population, 1, 0]
      
          parameter = [transmission_rate/population, transmission_rate/R_0]
          t = 0
          data_out = []
          data_out.append((t, state[0], state[1], state[2]))
      
          while (t < max_time and state[1]>0):
          #while state[1]>0:
              prob = probablities(state, parameter)
      
              tau = random.expovariate(sum(prob))
              t += tau
      
              r = random.uniform(0,1)*sum(prob)
              if r < prob[0]:
      
                  state[0] -= 1
                  state[1] += 1
      
              else:
      
                  state[1] -=1
                  state[2] +=1
      
              data_out.append((t, state[0], state[1], state[2]))
          output_arr = np.array(data_out)
      
          return output_arr
      
      if __name__ == "__main__":
          random.seed(3)
          a = gillespie(1000, 0.1, 2, 100)
      
          plt.figure(figsize=(10,15))
          plt.title("infected and recover")
          plt.plot(a[:,0],a[:,2], label = "infected")
          plt.plot(a[:,0], a[:,3], label = "recovered")
          plt.plot(a[:,0], a[:,1], label = "suspectibal")
          plt.legend()
          plt.show()
          `
    }
  },
  computed: {

  },
  mounted () {
    // COVID-19 POPUP FOR JS
      let _self = this;
    $(document).ready(function (argument) {
      $(".covid_19_popup_heading.cursor-pontior").click( function(){
        _self.contact_rate=''
        _self.recovered=''
        $(window).scrollTop(0);
        $(".covid_19_popup_heading").addClass("d-none");
        $("body").toggleClass("covid_19_popup_actv");
        $(".covid_19_popup").addClass("popup_actv");
        _self.chartDraw = true
        _self.graphSHow = true
        setTimeout(() => {
        _self.graphSHowLabel =  true
        $(".covid_19_popup_mainheading_btn").click( function(){
          $(window).scrollTop(0);
          $(".sir_model_popup").addClass("active");
          _self.renderMathJax()
        });
        $(document).click(function(event) {
          //if you click on anything except the modal itself or the "open modal" link, close the modal
          if (!$(event.target).closest(".sir_model_popup  .light_bg_popup, .covid_19_popup_mainheading, .header_fix .navbar").length) {
            $(".sir_model_popup").removeClass("active");
          }
        });
        $(".sir_model_popup_close_btn").click( function(){
          $(".sir_model_popup").removeClass("active");
        });
        $(".covid_19_popup_subheading_btn").click( function(){
          $(window).scrollTop(0);
          $(".gillespie_algorithm_popup").addClass("active");
          _self.renderMathJax()
          // $('.source_code_btn').click(function(){
          //   if($('.syntax_highlighter_wrp').hasClass('d-none')){
          //     $('.syntax_highlighter_wrp').removeClass('d-none')
          //   }else{
          //     $('.syntax_highlighter_wrp').addClass('d-none')
          //   }
          // })
        });
        $(document).click(function(event) {
          //if you click on anything except the modal itself or the "open modal" link, close the modal
          if (!$(event.target).closest(".gillespie_algorithm_popup  .light_bg_popup, .covid_19_popup_subheading_btn").length) {
            $(".gillespie_algorithm_popup").removeClass("active");
          }
        });
        $(".gillespie_algorithm_close_btn").click( function(){
          $(".gillespie_algorithm_popup").removeClass("active");
        });
        }, 100);
        $(".covid_19_popup_expand_btn .fa").click( function(){
          $("body").removeClass("covid_19_popup_actv");
          $(".covid_19_popup").removeClass("popup_actv");
          $(".covid_19_popup_heading").removeClass("d-none");
          _self.chartDraw = false
          _self.graphSHow = false
          _self.chartGraphLoading =  true
          _self.effective_contact_rate=''
          _self.recover_inday=''
          _self.graphSHowLabel = false
        });
      });
      $(document).click(function(event) {
        //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!$(event.target).closest(".covid_19_popup_heading.cursor-pontior,.covid_19_popup_inner").length) {
          $("body").removeClass("covid_19_popup_actv");
          $(".covid_19_popup").removeClass("popup_actv");
          $(".covid_19_popup_heading").removeClass("d-none");
          _self.chartDraw = false
          _self.graphSHow = false
          _self.chartGraphLoading =  true
          _self.effective_contact_rate=''
          _self.recover_inday=''
        _self.graphSHowLabel = false
        }
      });
      });
      window.addEventListener('keyup', function(event) {
          // If  ESC key was pressed...
          if (event.keyCode === 27) {
            _self.chartDraw = false
            _self.graphSHow = false
            _self.chartGraphLoading =  true
            $("body").removeClass("covid_19_popup_actv");
            $(".covid_19_popup").removeClass("popup_actv");
            $(".covid_19_popup_heading").removeClass("d-none");
            _self.effective_contact_rate=''
            _self.recover_inday=''
            _self.graphSHowLabel = false
          }
      });
      this.renderMathJax()
  },
  methods: {
    renderMathJax(){
      setTimeout(()=>{
        if(window.MathJax){
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log('done'));
        }
      },10)
    },
  someHandlerContactRate(){
    if(this.contact_rate > 2 && this.contact_rate < 15){
      this.recovered = (parseInt(this.contact_rate) + 1)
    }
  },
  someHandlerRecoveredRate(){
    if(this.recovered > 3 && this.recovered < 16){
      this.contact_rate = (parseInt(this.recovered) - 1)
    }
  },
  validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          this.graphSHowLabel =  false
          this.graphSHow = false
          this.effective_contact_rate = this.contact_rate
          this.recover_inday = this.recovered
          setTimeout(() => {
            this.graphSHow = true
          }, 10);
          setTimeout(() => {
            this.graphSHowLabel =  true
            this.$validator.reset()
          },111);
        }
      })
      }
  },
  watch:{
  }
}